import { IconName } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactElement } from 'react'

const placeholders = {
  fileImageLight: 'file-image',
  filePowerpointLight: 'file-powerpoint',
  fileVideoLight: 'file-video',
}

// Added a string type since the BE sometimes returns a string for the file name
// See usage in thumb-rate-request-modal.tsx
export type Placeholder = keyof typeof placeholders | string
interface QueueTypePlaceholderProps {
  fileName: Placeholder
  className?: string
  color?: string
}

/**
 * @deprecated this has been migrated to the web app and any changes should be made in both the web app and here
 */
export default function QueueTypePlaceholder({ fileName, className, color }: QueueTypePlaceholderProps): ReactElement {
  const iconName = (placeholders[fileName] || 'file-image') as IconName
  return <FontAwesomeIcon icon={['fal', iconName]} color={color} className={className} />
}
